import React from 'react'
import {
  useParams
} from "react-router-dom";

import { obtenerdetallempleado } from '../../Redux/EmpleadoDucks';
import { obtenerpdiperiodovigentexemp } from '../../Redux/ReportesDucks';
import { obtenerhistorialpercepcionesemp } from '../../Redux/ReportesDucks';
import { obtenerhistorialincidenciasemp } from '../../Redux/ReportesDucks';
import { obtenerhistorialmovimientosemp } from '../../Redux/ReportesDucks';
import { obtenerhistorialdeduccionesemp } from '../../Redux/ReportesDucks';
import { useDispatch, useSelector } from 'react-redux';
import { Divider, Grid, Typography } from '@mui/material';
import PeriodoVigente from './Empleado/PeriodoVigente';
import Percepciones from './Empleado/Percepciones';
import Deducciones from './Empleado/Deducciones'
import Movimientos from './Empleado/Movimientos'
import Incidencias from './Empleado/Incidencias'
import EstatusEmpleado from './EstatusEmpleado';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { useNavigate } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import MuiAppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import MenuPerfil from '../loggin/MenuPerfil';
const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const HistorialDetalle = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let { Id } = useParams();
  let { Cod } = useParams()
  let { Bd } = useParams()
  const { open } = props
  const { appbar } = props

  const [dataemple] = useSelector(store => store.empleado.dataempleado);
  const empperiodo = useSelector(store => store.reportes.datoperiodo);
  const emppercepciones = useSelector(store => store.reportes.datopercepciones);
  const empdeducciones = useSelector(store => store.reportes.datodeducciones);
  const empincidencias = useSelector(store => store.reportes.datoincidencias);
  const empmovimientos = useSelector(store => store.reportes.datomovimientos);

  React.useEffect(() => {
    const obtenerInfo = () => {
      dispatch(obtenerdetallempleado(Bd, Id))
      dispatch(obtenerpdiperiodovigentexemp(Bd, Id))
      dispatch(obtenerhistorialpercepcionesemp(Bd, Id))
      dispatch(obtenerhistorialdeduccionesemp(Bd, Id))
      dispatch(obtenerhistorialincidenciasemp(Bd, Id))
      dispatch(obtenerhistorialmovimientosemp(Bd, Id))
      dispatch(obtenerdetallempleado(Bd, Id))
    }
    obtenerInfo()
  }, [Bd, Id])


  return (
    <div>
      <AppBar position="absolute" color='info' open={open} elevation={0}>
        <Toolbar
          sx={{
            pr: '24px', // keep right padding when drawer closed
          }}
        >
          <IconButton
            edge="start"
            color='success'
            aria-label="open drawer"
            onClick={appbar}
            sx={{
              marginRight: '36px',
              ...(open && { display: 'none' }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <MenuPerfil />

        </Toolbar>
        <Divider />
      </AppBar>
      <Breadcrumbs aria-label="breadcrumb">
        <Link underline="hover" color="inherit" onClick={() => navigate(-1)}>
          Historial
        </Link >

        <Link
          underline="none"
          color="text.primary"
          aria-current="page"
        >
          Detalles
        </Link>
      </Breadcrumbs>
      <Grid container >


        <Grid item xs={8} md={8}>
          {dataemple.descestadoempleado === 'Baja' ? (
            <Typography variant='h6' style={{ textDecoration: 'line-through' }}>
              {Cod} - {dataemple.nombrelargo}
            </Typography>) :
            <Typography variant='h6'>
              {Cod} - {dataemple.nombrelargo}
            </Typography>
          }          <EstatusEmpleado
            status={dataemple.descestadoempleado}
          />
        </Grid>
        <Grid item xs={4} md={4} >
          <Typography align='right' variant='body1'>
            DEPARTAMENTO: {dataemple.descripciondepto}
          </Typography>
        </Grid>
      </Grid>
      <br />

      <Grid container spacing={2} rowSpacing={2}>
        <Grid item md={12}>
          <Typography variant="" color="text.primary">Periodo vigente</Typography>
          <PeriodoVigente empperiodo={empperiodo} />
        </Grid>
        <Grid item md={6}>
          <Typography variant="" color="text.primary">Percepciones</Typography>
          <Percepciones emppercepciones={emppercepciones} />
        </Grid>
        <Grid item md={6}>
          <Typography variant="" color="text.primary">Deducciones</Typography>
          <Deducciones empdeducciones={empdeducciones} />
        </Grid>

        <Grid item md={6}>
          <Typography variant="" color="text.primary">Incidencias</Typography>
          <Incidencias empincidencias={empincidencias} />
        </Grid>
        <Grid item md={6}>
          <Typography variant="" color="text.primary">Movimientos</Typography>
          <Movimientos empmovimientos={empmovimientos} />
        </Grid>

      </Grid>
    </div>
  )
}

export default HistorialDetalle